export default __webpack_public_path__ + "static/media/usc-films-angular.1396ad1e.jpg";